import { createMuiTheme } from '@material-ui/core/styles';

import config from '../../config';

/**
 * WARNING: Every line on this file is required, you can edit one but never delete one key/line... without a lead validation.
 */
export default createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    type: 'light',
    background: {
      default: '#f1f1f1',
      paper: '#fafafa',
      cardHeader: '#e0e0e0'
    },
    primary: {
      main: config.primary_color || '#8378F4'
    },
    secondary: {
      main: config.secondary_color || '#4E4BC6'
    }
  },
  overrides: {
    MuiSpeedDialIcon: {
      root: {
        color: config.dark_color || '#1A2123'
      }
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: config.grey_color || '#e0e0e0'
      }
    },
    MuiMenuItem: {
      root: {
        minHeight: 32,
        fontSize: 15
      }
    },
    MuiTableCell: {
      root: {
        padding: 12
      }
    },
    MuiTypography: {
      caption: {
        fontSize: 10
      },
      body2: {
        fontSize: 12
      },
      subtitle2: {
        fontSize: 12
      },
      h2: {
        '@media (max-width: 768px)': {
          fontSize: '2.75rem'
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 16
      }
    },
    MuiTableHead: {
      root: {
        backgroundColor: '#f3f3f3'
      }
    }
  },
  error: {
    dark: '#f44336'
  }
});
